/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/User/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import { userKey, baseApiUrl, avatarPhoto } from '@/global'
import store from './store/store.js'
import axios from "axios";


Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [

        {
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                {
                    path: '/',
                    name: 'home',
                    component: () => import('./views/Home.vue'),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: '/page2',
                    name: 'page-2',
                    component: () => import('./views/Page2.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Page 2', active: true },
                        ],
                        pageTitle: 'Page 2',
                        rule: 'editor'
                    },
                },
                {
                    path: '/produtos',
                    name: 'produtos',
                    component: () => import('./views/pages/products/ProductsList.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Produtos', active: true },
                        ],
                        pageTitle: 'Produtos',
                        rule: 'editor'
                    },
                },

                {
                    path: '/clientes',
                    name: 'clientes',
                    component: () => import('./views/pages/customers/CustomersList.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Clientes', active: true },
                        ],
                        pageTitle: 'Clientes',
                        rule: 'editor'
                    },
                },
                {
                    path: '/gestao',
                    name: 'Gestão do Sistema',
                    component: () => import('./views/pages/management/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Gestão do Sistema', active: true },
                        ],
                        pageTitle: 'Gestão do Sistema',
                        rule: 'editor'
                    },
                },
                {
                    path: '/marcas',
                    name: 'Gerenciar Marcas',
                    component: () => import('./views/pages/trademark/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Gestão do Sistema', url: '/gestao'  },
                            { title: 'Gerenciar Marcas', active: true },
                        ],
                        pageTitle: 'Gerenciar Marcas',
                        rule: 'editor'
                    },
                },
                {
                    path: '/marcas/nova-marca',
                    name: 'Nova Marca',
                    component: () => import('./views/pages/trademark/New.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Gestão do Sistema', url: '/gestao'  },
                            { title: 'Gerenciar Marcas',  url: '/marcas'  },
                            { title: 'Editar Marca', active: true   },
                        ],
                        pageTitle: 'Gerenciar Marcas',
                        rule: 'editor'
                    },
                },
                {
                    path: '/marcas/editar/:idTrademark',
                    name: 'Editar Marca',
                    component: () => import('./views/pages/trademark/Edit.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Gestão do Sistema', url: '/gestao'  },
                            { title: 'Gerenciar Marcas', url: '/marcas'  },
                            { title: 'Editar Marca', active: true   },
                        ],
                        pageTitle: 'Gerenciar Marcas',
                        rule: 'editor'
                    },
                },
                {
                    path: '/perfil',
                    name: 'perfil',
                    component: () => import('@/views/pages/profile/UserSettings.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Perfil', active: true },
                        ],
                        pageTitle: 'Perfil',
                    },
                },
                {
                    path: '/usuarios',
                    name: 'usuarios',
                    component: () => import('@/views/pages/user/user-list/UserList.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Usuários', active: true },
                           
                        ],
                        pageTitle: 'Administração',
                        rule: 'editor'
                    },
                },
                {
                    path: '/usuarios/novo',
                    name: 'usuarios-novo',
                    component: () => import('@/views/pages/user/user-list/New.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Usuários', url: '/usuarios'  },
                            { title: 'Novo Usuário', active: true },
                        ],
                        pageTitle: 'Administração',
                        rule: 'editor'
                    },
                },
                {
                    path: '/usuarios/:idUser',
                    name: 'usuarios-edicao',
                    component: () => import('@/views/pages/user/user-edit/UserEdit.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Usuário', url: '/usuarios' },
                            { title: 'Editar', active: true },
                        ],
                        pageTitle: 'Editar Usuário',
                        rule: 'editor'
                    },
                },
                {
                    path: '/usuarios-clientes/:idUserCustomer',
                    name: 'usuarios-clientes-edicao',
                    component: () => import('@/views/pages/user/user-edit-customer/UserEditCustomer.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Usuário', url: '/usuarios' },
                            { title: 'Editar', active: true },
                        ],
                        pageTitle: 'Editar Usuário',
                        rule: 'editor'
                    },
                },
                // Equipments Order
                {
                    path: '/equipamentos',
                    name: 'equipamentos',
                    component: () => import('./views/pages/equipments-order/ListEquipmentOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        equipmentIsVisible: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Equipamentos', active: true },
                        ],
                        pageTitle: 'Pedido de Equipamentos',
                        rule: 'editor'
                    },
                },
                {
                    path: '/equipamentos/concluidos',
                    name: 'equipamentos-concluidos',
                    component: () => import('./views/pages/equipments-order/ListEquipmentOrderCompleted.vue'),
                    meta: {
                        requiresAuth: true,
                        equipmentIsVisible: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Equipamentos', url: '/equipamentos' },
                            { title: 'Pedido de Equipamentos Concluídos', active: true },
                        ],
                        pageTitle: 'Pedido de Equipamentos',
                        rule: 'editor'
                    },
                },

                {
                    path: '/equipamentos/novo-pedido',
                    name: 'equipamentos-novo-pedido',
                    component: () => import('./views/pages/equipments-order/NewOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        equipmentIsVisible: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Equipamentos',url: '/equipamentos' },
                            { title: 'Novo Pedido de Equipamentos', active: true },
                        ],
                        pageTitle: 'Pedido de Equipamentos',
                        rule: 'editor'
                    }, 
                },
                {
                    path: '/equipamentos/editar/:idOrder',
                    name: 'equipamentos-edicao',
                    component: () => import('@/views/pages/equipments-order/EditOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        equipmentIsVisible: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Equipamentos', url: '/equipamentos' },
                            { title: 'Editar', active: true },
                        ],
                        pageTitle: 'Editar Pedido',
                        rule: 'editor'
                    },
                },
                {
                    path: '/etapa-equipamentos/:idEquipmentOrder',
                    name: 'etapa-equipamentos',
                    component: () => import('./views/pages/stage/StageEquipmentOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        equipmentIsVisible: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Equipamentos', url: '/equipamentos' },
                            { title: 'Editar Etapa', active: true },
                        ],
                        pageTitle: 'Editar Etapa'
                    },
                },
                {
                    path: '/equipamentos-relatorio',
                    name: 'equipamentos-relatorio',
                    component: () => import('./views/pages/report/equipmentsOrder/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Equipamentos', url: '/equipamentos' },
                            { title: 'Relatório', active: true },
                        ],
                        pageTitle: 'Equipamentos Relatório'
                    },
                },
                {
                    path: '/equipamentos/busca-avancada',
                    name: 'equipamentos-busca-avancada',
                    component: () => import('@/views/pages/order-search/equipments/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        equipmentIsVisible: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Equipamentos', url: '/equipamentos' },
                            { title: 'Busca Avançada', active: true },
                        ],
                        pageTitle: 'Busca Avançada',
                        rule: 'editor'
                    },
                },
                // Supplies Order

                {
                    path: '/suprimentos',
                    name: 'suprimentos',
                    component: () => import('./views/pages/supplies-order/ListSuppliesOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Suprimentos', active: true },
                        ],
                        pageTitle: 'Pedido de Suprimentos',
                        rule: 'editor'
                    },
                },
                {
                    path: '/suprimentos/concluidos',
                    name: 'suprimentos-concluidos',
                    component: () => import('./views/pages/supplies-order/ListSuppliesCompleted.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Suprimentos', active: true },
                        ],
                        pageTitle: 'Pedido de Suprimentos',
                        rule: 'editor'
                    },
                },
                {
                    path: '/suprimentos/novo-pedido',
                    name: 'suprimentos-novo-pedido',
                    component: () => import('./views/pages/supplies-order/NewOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Suprimentos',url: '/suprimentos' },
                            { title: 'Novo Pedido de Suprimentos', active: true },
                        ],
                        pageTitle: 'Pedido de Suprimentos',
                        rule: 'editor'
                    },
                },
                {
                    path: '/suprimentos/editar/:idOrder',
                    name: 'suprimentos-edicao',
                    component: () => import('./views/pages/supplies-order/EditOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Suprimentos', url: '/suprimentos' },
                            { title: 'Editar', active: true },
                        ],
                        pageTitle: 'Editar Pedido',
                        rule: 'editor'
                    },
                },
                {
                    path: '/etapa-suprimentos/:idSuppliesOrder',
                    name: 'etapa-suprimentos',
                    component: () => import('./views/pages/stage/StageSuppliesOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Suprimentos', url: '/suprimentos' },
                            { title: 'Editar Etapa', active: true },
                        ],
                        pageTitle: 'Editar Etapa'
                    },
                },
                {
                    path: '/suprimentos-relatorio',
                    name: 'suprimentos-relatorio',
                    component: () => import('./views/pages/report/suppliesOrder/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Suprimentos', url: '/suprimentos' },
                            { title: 'Relatório', active: true },
                        ],
                        pageTitle: 'Suprimentos Relatório'
                    },
                },
                {
                    path: '/suprimentos/busca-avancada',
                    name: 'suprimentos-busca-avancada',
                    component: () => import('@/views/pages/order-search/supplies/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        equipmentIsVisible: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Suprimentos', url: '/suprimentos' },
                            { title: 'Busca Avançada', active: true },
                        ],
                        pageTitle: 'Busca Avançada',
                        rule: 'editor'
                    },
                },
                // Parts Order
                  {
                    path: '/pecas',
                    name: 'pecas',
                    component: () => import('./views/pages/parts-order/ListPartsOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Peças', active: true },
                        ],
                        pageTitle: 'Pedido de Peças',
                        rule: 'editor'
                    },
                },
                {
                    path: '/pecas/concluidos',
                    name: 'pecas-concluidos',
                    component: () => import('./views/pages/parts-order/ListPartsCompleted.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Peças', active: true },
                        ],
                        pageTitle: 'Pedido de Peças',
                        rule: 'editor'
                    },
                },
                {
                    path: '/pecas/novo-pedido',
                    name: 'pecas-novo-pedido',
                    component: () => import('./views/pages/parts-order/NewOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Peças',url: '/pecas' },
                            { title: 'Novo Pedido de Peças', active: true },
                        ],
                        pageTitle: 'Pedido de Peças',
                        rule: 'editor'
                    },
                },
                {
                    path: '/pecas/editar/:idOrder',
                    name: 'pecas-edicao',
                    component: () => import('./views/pages/parts-order/EditOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Peças', url: '/pecas' },
                            { title: 'Editar', active: true },
                        ],
                        pageTitle: 'Editar Pedido',
                        rule: 'editor'
                    },
                },
                {
                    path: '/etapa-pecas/:idPartsOrder',
                    name: 'etapa-pecas',
                    component: () => import('./views/pages/stage/StagePartsOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Peças', url: '/pecas' },
                            { title: 'Editar Etapa', active: true },
                        ],
                        pageTitle: 'Editar Etapa'
                    },
                },
                {
                    path: '/pecas/busca-avancada',
                    name: 'pecas-busca-avancada',
                    component: () => import('@/views/pages/order-search/parts/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        equipmentIsVisible: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Peças', url: '/pecas' },
                            { title: 'Busca Avançada', active: true },
                        ],
                        pageTitle: 'Busca Avançada',
                        rule: 'editor'
                    },
                },
                {
                    path: '/pecas-relatorio',
                    name: 'pecas-relatorio',
                    component: () => import('./views/pages/report/partsOrder/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Relatórios de Peças', url: '/pecas' },
                            { title: 'Relatório', active: true },
                        ],
                        pageTitle: 'Peças Relatório'
                    },
                },
                 // Labor Order
                 {
                    path: '/mao-de-obra',
                    name: 'mao-de-obra',
                    component: () => import('./views/pages/labor-order/ListLaborOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Mão de Obra', active: true },
                        ],
                        pageTitle: 'Pedido de Mão de Obra',
                        rule: 'editor'
                    },
                },
                {
                    path: '/mao-de-obra/concluidos',
                    name: 'mao-de-obra-concluidos',
                    component: () => import('./views/pages/labor-order/ListLaborCompleted.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Mão de Obra', active: true },
                        ],
                        pageTitle: 'Pedido de Mão de Obra',
                        rule: 'editor'
                    },
                },
                {
                    path: '/mao-de-obra/novo-pedido',
                    name: 'mao-de-obra-novo-pedido',
                    component: () => import('./views/pages/labor-order/NewOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Mão de Obra',url: '/mao-de-obra' },
                            { title: 'Novo Pedido de Mão de Obra', active: true },
                        ],
                        pageTitle: 'Pedido de Mão de Obra',
                        rule: 'editor'
                    },
                },
                {
                    path: '/mao-de-obra/:idOrder',
                    name: 'mao-de-obra-visualizar',
                    component: () => import('@/views/pages/view-order/ViewOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Mão de Obra', url: '/mao-de-obra' },
                            { title: 'Visualizar', active: true },
                        ],
                        pageTitle: 'Visualizar Pedido',
                        rule: 'editor'
                    },
                },
                {
                    path: '/mao-de-obra/editar/:idOrder',
                    name: 'mao-de-obra-edicao',
                    component: () => import('./views/pages/labor-order/EditOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Mão de Obra', url: '/mao-de-obra' },
                            { title: 'Editar', active: true },
                        ],
                        pageTitle: 'Editar Pedido',
                        rule: 'editor'
                    },
                },
                {
                    path: '/etapa-mao-de-obra/:idLaborOrder',
                    name: 'etapa-mao-de-obra',
                    component: () => import('./views/pages/stage/StageLaborOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Mão de Obra', url: '/mao-de-obra' },
                            { title: 'Editar Etapa', active: true },
                        ],
                        pageTitle: 'Editar Etapa'
                    },
                },
                {
                    path: '/mao-de-obra-relatorio',
                    name: 'mao-de-obra-relatorio',
                    component: () => import('./views/pages/report/laborOder/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Mão de Obra', url: '/mao-de-obra' },
                            { title: 'Relatório', active: true },
                        ],
                        pageTitle: 'Mão de Obra Relatório'
                    },
                },
                 // Gold Order
                 {
                    path: '/ouro',
                    name: 'ouro',
                    component: () => import('./views/pages/gold-order/ListGoldOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Ouro', active: true },
                        ],
                        pageTitle: 'Pedido de Ouro',
                        rule: 'editor'
                    },
                },
                {
                    path: '/ouro/concluidos',
                    name: 'ouro-concluidos',
                    component: () => import('./views/pages/gold-order/ListGoldOrderCompleted.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Ouro', active: true },
                        ],
                        pageTitle: 'Pedido de Ouro',
                        rule: 'editor'
                    },
                },
                {
                    path: '/ouro/novo-pedido',
                    name: 'ouro-novo-pedido',
                    component: () => import('./views/pages/gold-order/NewOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Ouro',url: '/ouro' },
                            { title: 'Novo Pedido de Ouro', active: true },
                        ],
                        pageTitle: 'Pedido de Ouro',
                        rule: 'editor'
                    },
                },
                {
                    path: '/ouro/:idOrder',
                    name: 'ouro-visualizar',
                    component: () => import('@/views/pages/view-order/ViewOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Ouro', url: '/ouro' },
                            { title: 'Visualizar', active: true },
                        ],
                        pageTitle: 'Visualizar Pedido',
                        rule: 'editor'
                    },
                },
                {
                    path: '/ouro/editar/:idOrder',
                    name: 'ouro-edicao',
                    component: () => import('@/views/pages/gold-order/EditOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Ouro', url: '/ouro' },
                            { title: 'Editar', active: true },
                        ],
                        pageTitle: 'Editar Pedido',
                        rule: 'editor'
                    },
                },
                {
                    path: '/etapa-ouro/:idGoldOrder',
                    name: 'etapa-ouro',
                    component: () => import('./views/pages/stage/StageGoldOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Ouro', url: '/ouro' },
                            { title: 'Editar Etapa', active: true },
                        ],
                        pageTitle: 'Editar Etapa'
                    },
                },
                 // Lease Order
                 {
                    path: '/locacao',
                    name: 'locacao',
                    component: () => import('./views/pages/lease-order/ListLeaseOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Locação', active: true },
                        ],
                        pageTitle: 'Pedido de Locação',
                        rule: 'editor'
                    },
                },
                {
                    path: '/locacao/concluidos',
                    name: 'locacao-concluidos',
                    component: () => import('./views/pages/lease-order/ListLeaseOrderCompleted.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Locação', active: true },
                        ],
                        pageTitle: 'Pedido de Locação',
                        rule: 'editor'
                    },
                },
                {
                    path: '/locacao/novo-pedido',
                    name: 'locacao-novo-pedido',
                    component: () => import('./views/pages/lease-order/NewOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Locação',url: '/locacao' },
                            { title: 'Novo Pedido de Locação', active: true },
                        ],
                        pageTitle: 'Pedido de Locação',
                        rule: 'editor'
                    },
                },
                {
                    path: '/locacao/:idOrder',
                    name: 'locacao-visualizar',
                    component: () => import('@/views/pages/view-order/ViewOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Locação', url: '/locacao' },
                            { title: 'Visualizar', active: true },
                        ],
                        pageTitle: 'Visualizar Pedido',
                        rule: 'editor'
                    },
                },
                {
                    path: '/locacao/editar/:idOrder',
                    name: 'locacao-edicao',
                    component: () => import('./views/pages/lease-order/EditOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Locação', url: '/locacao' },
                            { title: 'Editar', active: true },
                        ],
                        pageTitle: 'Editar Pedido',
                        rule: 'editor'
                    },
                },
                {
                    path: '/etapa-locacao/:idLeaseOrder',
                    name: 'etapa-locacao',
                    component: () => import('./views/pages/stage/StageLeaseOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Locação', url: '/locacao' },
                            { title: 'Editar Etapa', active: true },
                        ],
                        pageTitle: 'Editar Etapa'
                    },
                },

                //Revision
                
                {
                    path: '/revisao-equipamentos',
                    name: 'revisao-equipamentos',
                    component: () => import('./views/pages/equipment-review-order/ListSuppliesReview.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Revisao Equipamentos', active: true },
                        ],
                        pageTitle: 'Revisao Equipamentos',
                        rule: 'editor'
                    },
                },
                {
                    path: '/revisao-equipamentos/concluidos',
                    name: 'revisao-equipamentos-concluidos',
                    component: () => import('./views/pages/equipment-review-order/ListSuppliesReviewCompleted.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Revisao Equipamentos', active: true },
                        ],
                        pageTitle: 'Revisao Equipamentos',
                        rule: 'editor'
                    },
                },
                {
                    path: '/revisao-equipamentos/novo-pedido',
                    name: 'revisao-equipamentos-novo-pedido',
                    component: () => import('./views/pages/equipment-review-order/NewOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Revisao Equipamentos',url: '/revisao-equipamentos' },
                            { title: 'Novo Revisao Equipamentos', active: true },
                        ],
                        pageTitle: 'Revisao Equipamentos',
                        rule: 'editor'
                    },
                },
                {
                    path: '/revisao-equipamentos/editar/:idOrder',
                    name: 'revisao-equipamentos-edicao',
                    component: () => import('@/views/pages/equipment-review-order/EditOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Revisao Equipamentos', url: '/revisao-equipamentos' },
                            { title: 'Editar', active: true },
                        ],
                        pageTitle: 'Editar Pedido',
                        rule: 'editor'
                    },
                },
                {
                    path: '/revisao-equipamentos/busca-avancada',
                    name: 'revisao-equipamentos-busca-avancada',
                    component: () => import('@/views/pages/order-search/equipments-review/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        equipmentIsVisible: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Revisao Equipamentos', url: '/revisao-equipamentos' },
                            { title: 'Busca Avançada', active: true },
                        ],
                        pageTitle: 'Busca Avançada',
                        rule: 'editor'
                    },
                },
                {
                    path: '/etapa-revisao-equipamentos/:idEquipmentReviewOrder',
                    name: 'etapa-revisao-equipamentos',
                    component: () => import('./views/pages/stage/StageEquipmentReviewOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Revisao Equipamentos', url: '/revisao-equipamentos' },
                            { title: 'Editar Etapa', active: true },
                        ],
                        pageTitle: 'Editar Etapa'
                    },
                },
                {
                    path: '/cotacoes',
                    name: 'Cotações',
                    component: () => import('./views/pages/prices/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Cotações', url: '/cotacoes', active: true },
                        ],
                        pageTitle: 'Cotações'
                    },
                },
                {
                    path: '/cotacoes/nova',
                    name: 'cotacoes',
                    component: () => import('./views/pages/prices/New.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Cotações', url: '/cotacoes' },
                            { title: 'Nova Cotação', url: '/cotacoes', active: true },
                        ],
                        pageTitle: 'Nova Cotação'
                    },
                },
                {
                    path: '/cotacoes/:idPrices',
                    name: 'cotacoes-editar',
                    component: () => import('./views/pages/prices/Edit.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Cotações', url: '/cotacoes' },
                            { title: 'Editar Cotação', url: '/cotacoes', active: true },
                        ],
                        pageTitle: 'Editar Cotação'
                    },
                },
                {
                    path: '/orcamentos',
                    name: 'listar-orcamentos',
                    component: () => import('./views/pages/budgets/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                           { title: 'Orçamentos', active: true, url: '/orcamentos' },
                        ],
                        pageTitle: 'Listar Orçamentos'
                    },
                },
                {
                    path: '/orcamentos/novo-orcamento',
                    name: 'novo-orcamento',
                    component: () => import('./views/pages/budgets/New.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Orçamentos', url: '/orcamentos' },
                            { title: 'Novo Orçamento',  active: true,url: '/orcamentos/novo-orcamento' },
                        ],
                        pageTitle: 'Novo Orçamento'
                    },
                },
                {
                    path: '/orcamentos/equipamentos/editar-orcamento/:idBudget',
                    name: 'editar-orcamento-equipamentos',
                    component: () => import('./views/pages/budgets/Equipment.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Orçamentos', url: '/orcamentos' },
                            { title: 'Editar Orçamento Equipamentos',  active: true,url: '/orcamentos/editar-orcamento' },
                        ],
                        pageTitle: 'Editar Orçamento Equipamentos'
                    },
                },
                {
                    path: '/orcamentos/suprimentos/editar-orcamento/:idBudget',
                    name: 'editar-orcamento-suprimentos',
                    component: () => import('./views/pages/budgets/Supplies.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Orçamentos', url: '/orcamentos' },
                            { title: 'Editar Orçamento Suprimentos',  active: true,url: '/orcamentos/editar-orcamento' },
                        ],
                        pageTitle: 'Editar Orçamento Suprimentos'
                    },
                },
                {
                    path: '/lixeira',
                    name: 'Lixeira',
                    component: () => import('./views/pages/trash/Trash.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Lixeira', active: true },
                        ],
                        pageTitle: 'Lixeira',
                        
                    },
                },
                {
                    path: '/novidades',
                    name: 'Novidades',
                    component: () => import('./views/pages/news/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Novidades', active: true },
                        ],
                        pageTitle: 'Novidades',
                        
                    },
                },
                   // Lease Supplies Order

                   {
                    path: '/suprimentos-locacao',
                    name: 'suprimentos-locacao',
                    component: () => import('./views/pages/lease-supplies-order/ListLeaseSuppliesOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Suprimentos Locação', active: true },
                        ],
                        pageTitle: 'Pedido de Suprimentos Locação',
                        rule: 'editor'
                    },
                },
                {
                    path: '/suprimentos-locacao/concluidos',
                    name: 'suprimentos-locacao-concluidos',
                    component: () => import('./views/pages/lease-supplies-order/ListLeaseSuppliesCompleted.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Suprimentos Locação', active: true },
                        ],
                        pageTitle: 'Pedido de Suprimentos Locação',
                        rule: 'editor'
                    },
                },
                {
                    path: '/suprimentos-locacao/novo-pedido',
                    name: 'suprimentos-locacao-novo-pedido',
                    component: () => import('./views/pages/lease-supplies-order/NewOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Suprimentos Locação' ,url: '/suprimentos-locacao' },
                            { title: 'Novo Pedido de Suprimentos', active: true },
                        ],
                        pageTitle: 'Pedido de Suprimentos Locação',
                        rule: 'editor'
                    },
                },
                {
                    path: '/suprimentos-locacao/editar/:idOrder',
                    name: 'suprimentos-locacao-edicao',
                    component: () => import('./views/pages/lease-supplies-order/EditOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Suprimentos Locação', url: '/suprimentos-locacao' },
                            { title: 'Editar', active: true },
                        ],
                        pageTitle: 'Editar Pedido',
                        rule: 'editor'
                    },
                },
                {
                    path: '/suprimentos-locacao/busca-avancada',
                    name: 'suprimentos-locacao-busca-avancada',
                    component: () => import('@/views/pages/order-search/lease-supplies/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        equipmentIsVisible: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Suprimentos Locação', url: '/suprimentos-locacao' },
                            { title: 'Busca Avançada', active: true },
                        ],
                        pageTitle: 'Busca Avançada',
                        rule: 'editor'
                    },
                },
                {
                    path: '/etapa-suprimentos-locacao/:idLeaseSuppliesOrder',
                    name: 'etapa-suprimentos-locacao',
                    component: () => import('./views/pages/stage/StageLeaseSuppliesOrder.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pedido de Suprimentos Locação', url: '/suprimentos-locacao' },
                            { title: 'Editar Etapa', active: true },
                        ],
                        pageTitle: 'Editar Etapa'
                    },
                },
                {
                    path: '/comissoes',
                    name: 'comissoes',
                    component: () => import('./views/pages/comission/index.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Comissões', active: true },
                        ],
                        pageTitle: 'Comissões'
                    },
                },
                {
                    path: '/faturas',
                    name: 'Faturas',
                    component: () => import('./views/pages/invoice/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Faturas', active: true },
                        ],
                        pageTitle: 'Faturas'
                    },
                },
                {
                    path: '/faturas/retorno',
                    name: 'Carregar Arquivo de Retorno',
                    component: () => import('./views/pages/invoice/BankReturn.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Faturas Enviadas',url: '/faturas'},
                            { title: 'Retorno', active: true },
                        ],
                        pageTitle: 'Faturas'
                    },
                },
                {
                    path: '/faturas/enviadas',
                    name: 'Faturas Enviadas',
                    component: () => import('./views/pages/invoice/Sent.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Faturas Não Enviadas', url: '/faturas' },
                            { title: 'Faturas Enviadas', active: true },
                        ],
                        pageTitle: 'Faturas'
                    },
                },
                {
                    path: '/faturas/editar/:idInvoice',
                    name: 'Editar Fatura',
                    component: () => import('./views/pages/invoice/EditInvoice.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Faturas Não Enviadas', url: '/faturas' },
                            { title: 'Editar', active: true  },
                        ],
                        pageTitle: 'Faturas'
                    },
                },
                {
                    path: '/faturas/nova-fatura',
                    name: 'Nova Fatura',
                    component: () => import('./views/pages/invoice/NewInvoice.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Faturas', url: '/faturas' },
                            { title: 'Nova Fatura', active: true },
                        ],
                        pageTitle: 'Nova Fatura'
                    },
                },
                {
                    path: '/ativos',
                    name: 'Listar Ativos Locação',
                    component: () => import('./views/pages/permanent-assets/ListAssets.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Ativos Locação',  active: true },
                        ],
                        pageTitle: 'Ativos Locação'
                    },
                },
                {
                    path: '/revenda',
                    name: 'Listar Ativos Revenda',
                    component: () => import('./views/pages/permanent-assets/ListAssetsResale.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Revenda',  active: true },
                        ],
                        pageTitle: 'Revenda'
                    },
                },
                {
                    path: '/ativos/novo-ativo',
                    name: 'Novo Ativo',
                    component: () => import('./views/pages/permanent-assets/NewAsset.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Ativos', url: '/ativos' },
                            { title: 'Novo Ativo', active: true },
                        ],
                        pageTitle: 'Novo Ativo'
                    },
                },
                {
                    path: '/ativos/:idPermanentAsset',
                    name: 'Editar Ativo',
                    component: () => import('./views/pages/permanent-assets/EditAsset.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Ativos', url: '/ativos' },
                            { title: 'Editar', active: true },
                        ],
                        pageTitle: 'Editar Ativo',
                        rule: 'editor'
                    },
                },

                {
                    path: '/contratos',
                    name: 'Listar Contratos',
                    component: () => import('./views/pages/contract-permanent-assets/ListContracts.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Contratos',  active: true },
                        ],
                        pageTitle: 'Contratos'
                    },
                },
                {
                    path: '/contratos/novo-contrato',
                    name: 'Novo Contrato',
                    component: () => import('./views/pages/contract-permanent-assets/NewContract.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Contratos', url: '/Contratos' },
                            { title: 'Novo Contrato', active: true },
                        ],
                        pageTitle: 'Novo Contrato'
                    },
                },
                {
                    path: '/contratos/:idContractPermanentAsset',
                    name: 'Editar Contrato',
                    component: () => import('./views/pages/contract-permanent-assets/EditContract.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Contratos', url: '/contratos' },
                            { title: 'Editar', active: true },
                        ],
                        pageTitle: 'Editar Contrato',
                        rule: 'editor'
                    },
                },
                {
                    path: '/solicitacao',
                    name: 'Solicitação de Peças',
                    component: () => import('./views/pages/parts-request/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Solicitação de Peças', active: true },
                        ],
                        pageTitle: 'Solicitação de Peças',
                        rule: 'editor'
                    },
                },
                {
                    path: '/solicitacao/nova-solicitacao',
                    name: 'Nova Solicitação de Peças',
                    component: () => import('./views/pages/parts-request/New.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Solicitação de Peças', url: '/solicitacao' },
                            { title: 'Nova Solicitação', active: true },
                        ],
                        pageTitle: 'Nova Solicitação',
                        rule: 'editor'
                    },
                },
                {
                    path: '/solicitacao/editar/:idPartsRequest',
                    name: 'Editar Solicitação de Peças',
                    component: () => import('./views/pages/parts-request/Edit.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Solicitação de Peças', url: '/solicitacao' },
                            { title: 'Editar', active: true },
                        ],
                        pageTitle: 'Editar Solicitação',
                        rule: 'editor'
                    },
                },
                {
                    path: '/solicitacao/etapa/:idPartsRequest',
                    name: 'Etapa',
                    component: () => import('./views/pages/parts-request/Stage.vue'),
                    meta: {
                        requiresAuth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Solicitação de Peças', url: '/solicitacao' },
                            { title: 'Etapa', active: true },
                        ],
                        pageTitle: 'Etapa',
                        rule: 'editor'
                    },
                },
                /*{
                    path: '/ativos/editar-ativo',
                    name: 'Editar Ativo',
                    component: () => import('./views/pages/permanentAssets/edit.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Ativos', url: '/ativos' },
                            { title: 'Editar', active: true },
                        ],
                        pageTitle: 'Editar Ativo'
                    },
                },*/
                //Redes Sociais Redirect
                {
                    path: '/facebook',
                    name: 'facebook',
                    beforeEnter() { location.href = 'https://www.facebook.com/copyjui/' }

                },
                {
                    path: '/youtube',
                    name: 'youtube',
                    beforeEnter() { location.href = 'https://www.youtube.com/channel/UCXEN9UGZDNNvMGfRGBe7U_g/' }

                },
                {
                    path: '/instagram',
                    name: 'instagram',
                    beforeEnter() { location.href = 'https://www.instagram.com/copyjui' }

                },

            ],
        },

        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: '/login',
                    name: 'page-login',
                    component: () => import('@/views/pages/Login.vue')
                },
                {
                    path: '/pages/error-404',
                    name: 'page-error-404',
                    component: () => import('@/views/pages/Error404.vue')
                },
                {
                    path: '/pages/reset-password',
                    name: 'page-reset-password',
                    component: () => import('@/views/pages/ResetPassword.vue')
                },
                {
                    path: '/pages/forgot-password',
                    name: 'page-forgot-password',
                    component: () => import('@/views/pages/ForgotPassword.vue')
                },
                {
                    path: '/pages/forgot-password-success',
                    name: 'page-forgot-password-success',
                    component: () => import('@/views/pages/ForgotPasswordSuccess.vue')
                },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

const defaultTitle = 'Copyjui Portal'

router.beforeEach(async (to, from, next) => {

    document.title = to.meta.pageTitle || defaultTitle;




 



    if (to.matched.some(record => record.meta.requiresAuth)) {
        const userInfo = localStorage.getItem(userKey)
        const avatarPhotoURL = localStorage.getItem(avatarPhoto)
        const userAuth = JSON.parse(userInfo)
        if (!userAuth) {
            router.push({ name: "page-login" });
            return
        }
        
        if(!userAuth.equipmentIsVisible){
            if (to.matched.some(record => record.meta.equipmentIsVisible)){
                router.push({ name: "home" });
            }
        }

        const res = await axios.post(`${baseApiUrl}/validateToken`, userAuth)
        if (res.data) {
            store.commit("SET_USER_INFO", userAuth)
            store.commit('SET_AVATAR', avatarPhotoURL)
            next()
        } else {
            localStorage.removeItem(userKey);
            router.push({ name: "page-login" });
        }
    } else {
        next()

    }


    if (to.matched.some(record => record.meta.requiresAdmin)) {
        const userInfo = localStorage.getItem(userKey)
        const userAuth = JSON.parse(userInfo)
        if (userAuth.userGroup == 'admin') {
            next()
        } else {
            router.push({ name: "home" });
        }
    }

   



})


router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

export default router
